import styled from 'styled-components';

const TargetWrapper = styled.div`
  flex: 1;
  cursor: pointer;
`;

export default TargetWrapper;



// WEBPACK FOOTER //
// ./elements/Popover/TargetWrapper.js